// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1xK5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _useDateFormatter = require("react-aria/useDateFormatter");
var _dateRangePicker = require("@react-spectrum/s2/DateRangePicker");
var _react = require("react");
"use client";
function Example() {
    let [range, setRange] = (0, _react.useState)({
        start: (0, _date.parseDate)('2025-02-03'),
        end: (0, _date.parseDate)('2025-02-12')
    });
    let formatter = (0, _useDateFormatter.useDateFormatter)({
        dateStyle: 'long'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                value: range,
                onChange: setRange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Selected range: ",
                    range ? formatter.formatRange(range.start.toDate((0, _date.getLocalTimeZone)()), range.end.toDate((0, _date.getLocalTimeZone)())) : '--'
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":[["getLocalTimeZone","1rmIt"],["parseDate","4CWCl"]],"react-aria/useDateFormatter":"7tLpA","@react-spectrum/s2/DateRangePicker":"hJ2AB","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hJ2AB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePickerContext", ()=>DateRangePickerContext);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _dateRangePicker = require("react-aria-components/DateRangePicker");
var _datePicker = require("./DatePicker");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
var _form = require("react-aria-components/Form");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _rangeCalendar = require("./RangeCalendar");
var _timeField = require("./TimeField");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DateRangePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DateRangePickerContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, placeholderValue, maxVisibleMonths = 1, createCalendar, commitBehavior, ...dateFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se15';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU15';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG15';
                }
            }
            if (props.isInForm) rules += ' DLwlgod15';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb15';
                else if (props.labelPosition === "top") rules += ' DM8Mfn15';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb15';
            else if (props.labelPosition === "top") rules += ' E4w1sLc15';
            if (props.labelPosition === "side") rules += ' CbRM95c15';
            else if (props.labelPosition === "top") rules += ' Cxaocre15';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a15';
                rules += ' vFHT6Dd15';
            } else {
                rules += ' -_6BNtrc-c15';
                rules += ' vFHT6Dd15';
            }
            rules += ' ea15';
            rules += ' _Fd15';
            rules += ' _FnuYUweb15';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc15';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG15';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c15';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc15';
            else rules += ' -BhX7R-F4dY0ec15';
            rules += ' -AJjOLd-UVkF0Db15';
            rules += ' qi9a9Xd15';
            rules += ' __ca15';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid, isOpen, state })=>{
            let placeholder = placeholderValue || undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props.minValue && 'hour' in props.minValue ? props.minValue : undefined;
            let timeMaxValue = props.maxValue && 'hour' in props.maxValue ? props.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            // Ideally, we could omit errorMessage here and let S2 Calendar read it from RAC's CalendarContext which already contains the resolved value via calendarProps from useDatePicker.
            // However, RAC's CalendarProps omits errorMessage, so reading it back from the context would require an unsafe cast. Instead, we resolve it here using the same logic as useDatePicker.
            let resolvedErrorMessage = typeof errorMessage === 'function' ? errorMessage(state.displayValidation) : errorMessage || state.displayValidation.validationErrors.join(' ');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr15';
                            rules += ' yXcEWr15';
                            rules += ' BXcEWr15';
                            rules += ' AXcEWr15';
                            if (props.size === "XL") rules += ' NBaYFfc15';
                            else if (props.size === "L") rules += ' N3JjxG15';
                            else if (props.size === "S") rules += ' NCe2o8c15';
                            else if (props.size === "XS") rules += ' NifsFYc15';
                            else rules += ' N4dY0ec15';
                            if (props.isQuiet) rules += ' _qd15';
                            else rules += ' _qtb15';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc15';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc15';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic15';
                            else rules += ' -Anxdcc-ZExJajc15';
                            rules += ' __v6TNLWb15';
                            rules += ' __Wb15';
                            rules += ' SMBFGYc15';
                            rules += ' RfBFGYc15';
                            rules += ' -S_-Sv15';
                            rules += ' -R_-Rp15';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dateField.DateInputContainer), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "start"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: " _va15 _ua15 Sj15 Rj15",
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: " _va15 _ub15 sd15 _Cb15",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.CalendarButton), {
                                    isOpen: isOpen,
                                    size: size,
                                    setButtonHasFocus: setButtonHasFocus
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _datePicker.CalendarPopover), {
                        shouldFlip: props.shouldFlip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rangeCalendar.RangeCalendar), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar,
                                commitBehavior: commitBehavior,
                                errorMessage: resolvedErrorMessage
                            }),
                            showTimeField && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " sd15 UB1JKEb15 qB1JKEb15 _qb15 Js7Vxmb15",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeField.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.startTime'),
                                        value: state.timeRange?.start || null,
                                        onChange: (v)=>state.setTime('start', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeField.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.endTime'),
                                        value: state.timeRange?.end || null,
                                        onChange: (v)=>state.setTime('end', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: resolvedErrorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"dfRo0","1":"i8L17","2":"1IADb","3":"a7PDz","4":"gNsA4","react/jsx-runtime":"2Is6Z","react-aria-components/DateRangePicker":"59rph","./DatePicker":"dwOW5","react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","react-aria-components/Form":"g7RKA","../intl/*.json":"gDH3q","./RangeCalendar":"fEve7","./TimeField":"jK89c","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dfRo0":[function() {},{}],"i8L17":[function() {},{}],"1IADb":[function() {},{}],"a7PDz":[function() {},{}],"gNsA4":[function() {},{}],"fEve7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendarContext", ()=>RangeCalendarContext);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _rangeCalendar = require("react-aria-components/RangeCalendar");
var _calendar = require("./Calendar");
var _slots = require("react-aria-components/slots");
var _react = require("react");
var _content = require("./Content");
var _field = require("./Field");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _text = require("react-aria-components/Text");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeCalendarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sd15';
    if (props.isMultiMonth) rules += ' -_4DHzJc-e4mUs15';
    else rules += ' -_4DHzJc-0u6p5b15';
    rules += ' _ta15';
    rules += ' Us7Vxmb15';
    rules += ' qs7Vxmb15';
    rules += ' __ca15';
    rules += ' -uq4sQ-Sp15';
    rules += ' -LnVzy-Z4dY0ec15';
    if (props.isMultiMonth) rules += ' -cYDWLb-ZFFQGNb15';
    else rules += ' -cYDWLb-ZnqRBTd15';
    if (props.isMultiMonth) {
        if (!width) rules += ' ZJ15';
    } else if (!width) rules += ' ZRqDA2c15';
    if (props.isMultiMonth) {
        if (!maxWidth) rules += ' Le4mUs15';
    } else if (!maxWidth) rules += ' La15';
    return rules;
};
const RangeCalendar = /*#__PURE__*/ (0, _react.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeCalendarContext);
    let { visibleMonths = 1, errorMessage, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let isMultiMonth = visibleMonths > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rangeCalendar.RangeCalendar), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: {
            ...UNSAFE_style,
            '--num-calendars': visibleMonths
        },
        className: (UNSAFE_className || '') + calendarStyles({
            isMultiMonth
        }, styles),
        children: ({ isInvalid, isDisabled })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                        values: [
                            [
                                (0, _content.HeaderContext),
                                null
                            ],
                            [
                                (0, _content.HeadingContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeader), {
                            visibleMonths: visibleMonths
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd15 _tc15 Us7Vxmb15 qs7Vxmb15 ed15",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGrid), {
                                months: i
                            }, i))
                    }),
                    isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        slot: "errorMessage",
                        className: (0, _field.helpTextStyles)({
                            isInvalid,
                            isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 2
                        })
                    })
                ]
            });
        }
    });
});

},{"0":"idi5K","1":"eR6vB","react/jsx-runtime":"2Is6Z","react-aria-components/RangeCalendar":"2DleA","./Calendar":"j5ASf","react-aria-components/slots":"bA6Cz","react":"a1TxN","./Content":"10r6w","./Field":"eI7CE","../intl/*.json":"gDH3q","react-aria-components/Text":"jt9fm","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"idi5K":[function() {},{}],"eR6vB":[function() {},{}],"jK89c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFieldContext", ()=>TimeFieldContext);
parcelHelpers.export(exports, "TimeField", ()=>TimeField);
var _jsxRuntime = require("react/jsx-runtime");
var _timeField = require("react-aria-components/TimeField");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
var _form = require("react-aria-components/Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TimeFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TimeField = /*#__PURE__*/ (0, _react.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TimeFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, ...timeFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeField.TimeField), {
        ref: ref,
        isRequired: isRequired,
        ...timeFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se15';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU15';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG15';
                }
            }
            if (props.isInForm) rules += ' DLwlgod15';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb15';
                else if (props.labelPosition === "top") rules += ' DM8Mfn15';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb15';
            else if (props.labelPosition === "top") rules += ' E4w1sLc15';
            if (props.labelPosition === "side") rules += ' CbRM95c15';
            else if (props.labelPosition === "top") rules += ' Cxaocre15';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b15';
                rules += ' vFHT6Dd15';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a15';
                rules += ' vFHT6Dd15';
            } else {
                rules += ' -_6BNtrc-c15';
                rules += ' vFHT6Dd15';
            }
            rules += ' ea15';
            rules += ' _Fd15';
            rules += ' _FnuYUweb15';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc15';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG15';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c15';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc15';
            else rules += ' -BhX7R-F4dY0ec15';
            rules += ' -AJjOLd-UVkF0Db15';
            rules += ' qi9a9Xd15';
            rules += ' __ca15';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr15';
                            rules += ' yXcEWr15';
                            rules += ' BXcEWr15';
                            rules += ' AXcEWr15';
                            if (props.size === "XL") rules += ' NBaYFfc15';
                            else if (props.size === "L") rules += ' N3JjxG15';
                            else if (props.size === "S") rules += ' NCe2o8c15';
                            else if (props.size === "XS") rules += ' NifsFYc15';
                            else rules += ' N4dY0ec15';
                            if (props.isQuiet) rules += ' _qd15';
                            else rules += ' _qtb15';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc15';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc15';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic15';
                            else rules += ' -Anxdcc-ZExJajc15';
                            rules += ' __v6TNLWb15';
                            rules += ' SMBFGYc15';
                            rules += ' RfBFGYc15';
                            rules += ' -S_-Sv15';
                            rules += ' -R_-Rv15';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInputContainer), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"chKdZ","1":"25K8F","react/jsx-runtime":"2Is6Z","react-aria-components/TimeField":"5wv9P","react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","react-aria-components/Form":"g7RKA","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"chKdZ":[function() {},{}],"25K8F":[function() {},{}],"jzc6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _dateRangePicker = require("@react-spectrum/s2/DateRangePicker");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
    defaultValue: {
        start: (0, _date.parseZonedDateTime)('2025-02-03T08:45:00[America/Los_Angeles]'),
        end: (0, _date.parseZonedDateTime)('2025-02-14T08:45:00[America/Los_Angeles]')
    }
});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":"4CWCl","@react-spectrum/s2/DateRangePicker":"hJ2AB","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3ny7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _provider = require("@react-spectrum/s2/Provider");
var _dateRangePicker = require("@react-spectrum/s2/DateRangePicker");
var _date = require("@internationalized/date");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.Provider), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
        defaultValue: {
            start: (0, _date.parseDate)('2025-02-03'),
            end: (0, _date.parseDate)('2025-02-14')
        }
    })
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2/Provider":"31Rc2","@react-spectrum/s2/DateRangePicker":"hJ2AB","@internationalized/date":"4CWCl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eBbxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _dateRangePicker = require("@react-spectrum/s2/DateRangePicker");
var _form = require("@react-spectrum/s2/Form");
var _button = require("@react-spectrum/s2/Button");
var _provider = require("@react-spectrum/s2/Provider");
"use client";
function Example(props) {
    let { locale } = (0, _provider.useLocale)();
    let now = (0, _date.today)((0, _date.getLocalTimeZone)());
    let disabledRanges = [
        [
            now,
            now.add({
                days: 5
            })
        ],
        [
            now.add({
                days: 14
            }),
            now.add({
                days: 16
            })
        ],
        [
            now.add({
                days: 23
            }),
            now.add({
                days: 24
            })
        ]
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                ...props,
                label: "Trip dates",
                startName: "startDate",
                endName: "endDate",
                minValue: (0, _date.today)((0, _date.getLocalTimeZone)()),
                isDateUnavailable: (date)=>(0, _date.isWeekend)(date, locale) || disabledRanges.some((interval)=>date.compare(interval[0]) >= 0 && date.compare(interval[1]) <= 0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                type: "submit",
                children: "Submit"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":"1rmIt","@react-spectrum/s2/DateRangePicker":"hJ2AB","@react-spectrum/s2/Form":"cHqN4","@react-spectrum/s2/Button":"gZHck","@react-spectrum/s2/Provider":"l34Wn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf15';
    else rules += ' _Le15';
    if (props.isStaticColor) rules += ' Oe15';
    else rules += ' Oh15';
    rules += ' OlOVIhfcebS7sd15';
    rules += ' OlOVIhfcebS7sd15';
    rules += ' _Mc15';
    rules += ' _Kd15';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr15';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s15';
    rules += ' oR3ltQc15';
    rules += ' nR3ltQc15';
    rules += ' kR3ltQc15';
    rules += ' jR3ltQc15';
    if (props.isStandalone) {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c15';
        rules += ' vFHT6Dd15';
    }
    if (props.isStandalone) {
        rules += ' xc15';
        rules += ' _xa15';
    }
    if (props.isStandalone) {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    }
    if (props.isStaticColor) rules += ' pl15';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po15';
        else if (props.isFocusVisible) rules += ' po15';
        else if (props.isHovered) rules += ' po15';
        else rules += ' pt15';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps15';
        else if (props.isFocusVisible) rules += ' ps15';
        else if (props.isHovered) rules += ' ps15';
        else rules += ' pu15';
    }
    rules += ' plOVIhfcA5Qiqd15';
    rules += ' plOVIhfcA5Qiqd15';
    rules += ' Yd15';
    rules += ' Xb15';
    rules += ' _2b15';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb15';
                rules += ' __Va15';
            } else if (props.isHovered) {
                rules += ' _Xb15';
                rules += ' __Va15';
            } else rules += ' _Xa15';
        }
    } else {
        rules += ' _Xb15';
        rules += ' __Va15';
    }
    rules += ' __ca15';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "L") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "S") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "XS") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a15';
        rules += ' vFHT6Dd15';
    } else {
        rules += ' -_6BNtrc-c15';
        rules += ' vFHT6Dd15';
    }
    if (props.size === "XL") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "L") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "S") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "XS") {
        rules += ' xb15';
        rules += ' _xa15';
    } else {
        rules += ' xb15';
        rules += ' _xa15';
    }
    if (props.size === "XL") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "L") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "S") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "XS") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    }
    if (props.fillStyle === "outline") rules += ' pm15';
    else if (props.fillStyle === "subtle") rules += ' pm15';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg15';
        else if (props.variant === "chartreuse") rules += ' pg15';
        else if (props.variant === "yellow") rules += ' pg15';
        else if (props.variant === "orange") rules += ' pg15';
        else if (props.variant === "notice") rules += ' pg15';
        else rules += ' px15';
    }
    rules += ' sd15';
    rules += ' ea15';
    rules += ' egLWx3bb15';
    rules += ' _oa15';
    rules += ' Sv15';
    rules += ' SgLWx3bd15';
    rules += ' Rv15';
    rules += ' RgLWx3bd15';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc15';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG15';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c15';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc15';
    } else if (!minWidth) rules += ' N4dY0ec15';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec15';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn15';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b15';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd15';
    else rules += ' -SFnbic-_Jb15';
    rules += ' -Bu7z1c-oH5kTnc15';
    rules += ' oj15';
    rules += ' nj15';
    rules += ' kj15';
    rules += ' jj15';
    rules += ' qc15';
    rules += ' qsd15';
    rules += ' -Qg41Lb-IAxCW0c15';
    rules += ' -Qg41Lb-gLWx3bIYB8I15';
    rules += ' MAyFGYc15';
    rules += ' Td15';
    rules += ' Qd15';
    rules += ' -aRvJDd-Tu7Fubd15';
    rules += ' _Ca15';
    if (props.fillStyle === "outline") rules += ' g_g15';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f15';
        else if (props.variant === "cinnamon") rules += ' gP15';
        else if (props.variant === "brown") rules += ' gO15';
        else if (props.variant === "turquoise") rules += ' gy15';
        else if (props.variant === "pink") rules += ' gT15';
        else if (props.variant === "magenta") rules += ' gS15';
        else if (props.variant === "fuchsia") rules += ' gR15';
        else if (props.variant === "purple") rules += ' gM15';
        else if (props.variant === "indigo") rules += ' gK15';
        else if (props.variant === "blue") rules += ' gG15';
        else if (props.variant === "cyan") rules += ' gC15';
        else if (props.variant === "seafoam") rules += ' gz15';
        else if (props.variant === "green") rules += ' gA15';
        else if (props.variant === "celery") rules += ' gv15';
        else if (props.variant === "chartreuse") rules += ' gJ15';
        else if (props.variant === "yellow") rules += ' gW15';
        else if (props.variant === "orange") rules += ' gV15';
        else if (props.variant === "red") rules += ' gU15';
        else if (props.variant === "gray") rules += ' gI15';
        else if (props.variant === "negative") rules += ' gU15';
        else if (props.variant === "notice") rules += ' gV15';
        else if (props.variant === "positive") rules += ' gA15';
        else if (props.variant === "neutral") rules += ' gI15';
        else if (props.variant === "informative") rules += ' gG15';
        else if (props.variant === "accent") rules += ' gG15';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm15';
        else if (props.variant === "cinnamon") rules += ' gq15';
        else if (props.variant === "brown") rules += ' gn15';
        else if (props.variant === "turquoise") rules += ' g515';
        else if (props.variant === "pink") rules += ' gx15';
        else if (props.variant === "magenta") rules += ' gD15';
        else if (props.variant === "fuchsia") rules += ' gr15';
        else if (props.variant === "purple") rules += ' go15';
        else if (props.variant === "indigo") rules += ' gl15';
        else if (props.variant === "blue") rules += ' g215';
        else if (props.variant === "cyan") rules += ' gk15';
        else if (props.variant === "seafoam") rules += ' g415';
        else if (props.variant === "green") rules += ' g115';
        else if (props.variant === "celery") rules += ' g715';
        else if (props.variant === "chartreuse") rules += ' gp15';
        else if (props.variant === "yellow") rules += ' gN15';
        else if (props.variant === "orange") rules += ' gQ15';
        else if (props.variant === "red") rules += ' gB15';
        else if (props.variant === "gray") rules += ' g615';
        else if (props.variant === "negative") rules += ' gB15';
        else if (props.variant === "notice") rules += ' gQ15';
        else if (props.variant === "positive") rules += ' g115';
        else if (props.variant === "neutral") rules += ' g615';
        else if (props.variant === "informative") rules += ' g215';
        else if (props.variant === "accent") rules += ' g215';
    }
    rules += ' _jf15';
    rules += ' _kJ8iPYd15';
    rules += ' hXMFGYc15';
    rules += ' mc15';
    rules += ' lc15';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS15';
        else if (props.variant === "notice") rules += ' i9VrKkd15';
        else if (props.variant === "positive") rules += ' ip17Jm15';
        else if (props.variant === "neutral") rules += ' i0ruhAb15';
        else if (props.variant === "informative") rules += ' iG1ze4d15';
        else if (props.variant === "accent") rules += ' iG1ze4d15';
        else rules += ' iA15';
    } else rules += ' iA15';
    rules += ' -_8sjo0b-t5ZbAob15';
    if (props.size === "XL") rules += ' -M_-MBaYFfc15';
    else if (props.size === "L") rules += ' -M_-M3JjxG15';
    else if (props.size === "S") rules += ' -M_-MCe2o8c15';
    else if (props.size === "XS") rules += ' -M_-MifsFYc15';
    else rules += ' -M_-M4dY0ec15';
    rules += ' -_k_-_kc15';
    rules += ' -h_-hc15';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG15';
                        rules += ' QAzEcG15';
                        rules += ' _Jb15';
                        rules += ' _Nc15';
                        rules += ' Pc15';
                        rules += ' _Yb15';
                        if (props.overflowMode === "wrap") rules += ' _7b15';
                        else if (props.overflowMode === "truncate") rules += ' _7c15';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja15"
                    }),
                    styles: " ZuUmpre15 FuUmpre15 I67logd15 _va15"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"3yrCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75V7h-13V5.25c0-.413.336-.75.75-.75m11.5 12H4.25c-.414 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5jnVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M12.237 16.455c-.196 0-.393-.077-.54-.23L6.21 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.288.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=DateRangePicker.b1d5927f.js.map
